// ==============================|| OVERRIDES - TOGGLE BUTTON ||============================== //

export default function ToggleButton(theme) {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          padding: '1.5px 12px',
          border: `0.5px solid transparent`,
          fontSize: 14,
          fontWeight: 400,
          lineHeight: '1.25rem',
          '& .MuiBadge-badge': {
            transform: 'none',
            marginLeft: 6,
            position: 'relative',
            padding: '0px 6px',
            height: 'auto',
            minWidth: 'auto',
            borderRadius: 2,
            backgroundColor: theme.customShadows.batchToggle,
            color: theme.palette.text.disabled,
          },
          '&.Mui-selected': {
            border: `0.5px solid ${theme.palette.primary.darker}`,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
              backgroundColor: theme.palette.secondary.main,
            },
            '& .MuiBadge-badge': {
              color: theme.palette.primary.darker,
            },
          },
          '&:hover': {
            border: `0.5px solid ${theme.palette.primary.darker}`,
            color: theme.palette.primary.darker,
            backgroundColor: theme.palette.secondary.main,
            '& .MuiBadge-badge': {
              color: theme.palette.primary.darker,
            },
          },
          '&.Mui-disabled': {
            borderColor: 'transparent',
            color: theme.palette.text.disabled,
          },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2,
          },
          '&:fullWidth': {
            borderRadius: 2,
          },
        },
      },
    },
  }
}
